import EditPractice from './EditPractice';
import EditRelations from './EditRelations';
import SearchPractices from './SearchPractices/SearchPractices';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { actions } from '../../context';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';


// TODO: this is old, duplicate functionality that needs an overhaul
const PracticeWorkflow = () => {

    const dispatch = useDispatch();

    const isOpen = useSelector(state => state.toggle.isPracticeWorkflowModalOpen);
    const practiceName = useSelector((state) => state.practiceWorkflow.workflowPractice.name);

    let stateProps;
    let {
        loading, 
        searchingPractices, 
        editingPractice, 
        editingRelations
    } = stateProps = useSelector((state) => state.practiceWorkflow.workFlowStatus, shallowEqual);

    const closeWorkflow = () => dispatch(actions.toggle.togglePracticeWorkflowModalOpen(false));

    useEffect(() => {
        return () => {
            dispatch(actions.practice.resetOfferingsStep2());
            dispatch(actions.toggle.triggerPracticeRefresh());
            dispatch(actions.toggle.activitiesRefresh());
            dispatch(actions.practiceWorkflow.setWorkflowStatus({
                loading: false,
                searchingPractices: true,
                editingPractice: false,
                editingRelations: false,
            }))
        }
    }, [dispatch, isOpen]);

    const modalProps = {className: 'text-light', style: { minWidth: '50vw' }, backdrop: "static"};
    if(loading) modalProps.className += ' text-center';

    const HeaderContent = (props) => {
        const { practiceName } = props;
        if(props.loading) return (<span className='h3'>Loading</span>);
        if(props.searchingPractices) return ('Search for a practice');
        if(props.editingPractice) return practiceName ? `Edit ${practiceName}` : 'Create new practice';
        if(props.editingRelations) return `Manage practice offerings for ${practiceName && `New Practice: ${practiceName}`}`;
        return (<span className='h3'>Loading</span>); 
    };

    return (
        <Modal centered isOpen={isOpen} toggle={closeWorkflow} {...modalProps}>
            <ModalHeader>
                <HeaderContent {...stateProps} practiceName={practiceName} />
            </ModalHeader>
            <ModalBody>

                {loading && (<div className="loading-spinner spin-animate mx-auto my-4"></div>)}

                {searchingPractices && (
                    <SearchPractices />
                )}

                {editingPractice && (
                    <EditPractice />
                )}

                {editingRelations && (
                    <EditRelations />
                )}

            </ModalBody>
            <ModalFooter>
                <Button onClick={closeWorkflow} className="border">
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default React.memo(PracticeWorkflow);
